var map = {
	"./8_VINOS_DE_COAHUILA.webp": 87228,
	"./BCN_valle_guadalupe_22.webp": 58566,
	"./Region_vinos_Cava_Freixenetqueretaro.webp": 4840,
	"./uvabajacalifornia.webp": 78296,
	"./uvasaguascalientes.webp": 71612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82576;